import React from 'react';
import { L2_ICON_SIZES } from '../../constants';
import type { L2IconType } from '../../types';

const DynamicBriefL2Icon = ({ size = 'sm' }: L2IconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={L2_ICON_SIZES[size]}
    height={L2_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 48 48"
  >
    <g filter="url(#dynamic_brief_svg__a)">
      <path fill="#fff" d="M38 3a2 2 0 0 1 2 2v37a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
    </g>
    <path
      fill="#E4E5E7"
      fillRule="evenodd"
      d="M39.5 42V5A1.5 1.5 0 0 0 38 3.5H6A1.5 1.5 0 0 0 4.5 5v37A1.5 1.5 0 0 0 6 43.5h32a1.5 1.5 0 0 0 1.5-1.5M40 5a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v37a2 2 0 0 0 2 2h32a2 2 0 0 0 2-2z"
      clipRule="evenodd"
    />
    <path fill="#C5C6C9" d="M37 31H7v1.5h30zM37 35H7v1.5h30zM7 39h13v1.5H7zM20 21V6H7v15z" />
    <path fill="#E8F094" d="M20 28v-5H7v5z" />
    <path fill="url(#dynamic_brief_svg__b)" d="M37 28V6H22v22z" />
    <g filter="url(#dynamic_brief_svg__c)">
      <path fill="#fff" d="M30 11a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H32a2 2 0 0 1-2-2z" />
    </g>
    <path
      fill="#E4E5E7"
      fillRule="evenodd"
      d="M42 9.5H32a1.5 1.5 0 0 0-1.5 1.5v10a1.5 1.5 0 0 0 1.5 1.5h10a1.5 1.5 0 0 0 1.5-1.5V11A1.5 1.5 0 0 0 42 9.5M32 9a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <path
      fill="#222325"
      d="M37.28 12.28a.28.28 0 1 0-.56 0 3.44 3.44 0 0 1-3.44 3.44.28.28 0 1 0 0 .56 3.44 3.44 0 0 1 3.44 3.44.28.28 0 1 0 .56 0 3.44 3.44 0 0 1 3.44-3.44.28.28 0 1 0 0-.56 3.44 3.44 0 0 1-3.44-3.44"
    />
    <defs>
      <filter
        id="dynamic_brief_svg__a"
        width={42}
        height={47}
        x={1}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_39984_15335" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_39984_15335" result="shape" />
      </filter>
      <filter
        id="dynamic_brief_svg__c"
        width={20}
        height={20}
        x={27}
        y={6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_39984_15335" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_39984_15335" result="shape" />
      </filter>
      <linearGradient id="dynamic_brief_svg__b" x1={22} x2={32.714} y1={28} y2={4.254} gradientUnits="userSpaceOnUse">
        <stop stopColor="#BBCE00" />
        <stop offset={1} stopColor="#005C25" />
      </linearGradient>
    </defs>
  </svg>
);
DynamicBriefL2Icon.displayName = 'DynamicBriefL2Icon';
export default DynamicBriefL2Icon;
